import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {CustomerSubscriptionsCreateRequestDTO,CustomerSubscriptionsUpdateRequestDTO,CustomerSubscriptionsDeleteRequestDTO,CustomerSubscriptionsReadByIdRequestDTO,CustomerSubscriptionsReadByTenantIdRequestDTO,CustomerSubscriptionsReadByPlanIdRequestDTO, PaymentDueStatusDTO} from 'src/app/AdvERP/companies/company-customer-subscriptions/company-customer-subscriptions.interface';
import {CustomerSubscriptions_create,CustomerSubscriptions_update,CustomerSubscriptions_delete,CustomerSubscriptions_readById,CustomerSubscriptions_readByTenantId,CustomerSubscriptions_readByPlanId, CustomerSubscriptions_status, CustomerSubscriptions_paymentDue} from 'src/app/GlobalVariables';

@Injectable({
    providedIn: 'root'
})
export class CustomerSubscriptionsService {

    private http = inject(HttpClient);

    CustomerSubscriptions_create(data: CustomerSubscriptionsCreateRequestDTO): Observable<any> {
        return this.http.post<any>(CustomerSubscriptions_create,data);
        // return this.http.post<any>("https://dev.ms.vnccy.com/AdvinMaster/customerSubscriptions/Create",data);
    }

    CustomerSubscriptions_update(data: CustomerSubscriptionsUpdateRequestDTO): Observable<any> {
        return this.http.post<any>(CustomerSubscriptions_update,data);
    }

    CustomerSubscriptions_delete(data: CustomerSubscriptionsDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(CustomerSubscriptions_delete,data);
       // return this.http.post<void>("https://dev.ms.vnccy.com/AdvinMaster/customerSubscriptions/Delete",data);
    }

    CustomerSubscriptions_readById(data: CustomerSubscriptionsReadByIdRequestDTO): Observable<any> {
        return this.http.post<any>(CustomerSubscriptions_readById,data);
    }

    CustomerSubscriptions_readByTenantId(
        data: CustomerSubscriptionsReadByTenantIdRequestDTO): Observable<any> {
        return this.http.post<any>(CustomerSubscriptions_readByTenantId,data);
    }

    CustomerSubscriptions_readByPlanId(
        data: CustomerSubscriptionsReadByPlanIdRequestDTO): Observable<any> {
        return this.http.post<any>(CustomerSubscriptions_readByPlanId,data);
    }

    CustomerSubscriptions_status(
        data: CustomerSubscriptionsReadByTenantIdRequestDTO): Observable<any> {
        return this.http.post<any>(CustomerSubscriptions_status, data);
    }

    CustomerSubscriptions_paymentDue(
        data: CustomerSubscriptionsReadByTenantIdRequestDTO): Observable<PaymentDueStatusDTO> {
        return this.http.post<PaymentDueStatusDTO>(CustomerSubscriptions_paymentDue, data);
    }
}
